import { Dialog } from '@e3dc-react/shell/Elements/Dialog'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { Box, Typography } from '@mui/material'
import React from 'react'

export interface DeleteChargingScheduleModalProps {
  onClose: () => void
  handleOnDelete: () => Promise<void>
  isDialogOpen: boolean
}

/**
 * Dialog component to inform user that he is about deleting the schedule.
 */
const DeleteChargingScheduleModal: React.VFC<DeleteChargingScheduleModalProps> = ({ onClose, handleOnDelete, isDialogOpen }) => {
  const { t } = useCustomTranslation()

  const modalActions = {
    primary: {
      name: t('common.delete'),
      onClick: handleOnDelete,
    },
    secondary: { name: t('common.cancel') },
  }

  return (
    <Dialog maxWidth="sm" title={t('emobility.vehicle-integration.charging-schedule.delete-schedule.title')} actions={modalActions} onClose={onClose}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="body1">{t('emobility.vehicle-integration.charging-schedule.delete-schedule-dialog.text')}</Typography>
      </Box>
    </Dialog>
  )
}

export default DeleteChargingScheduleModal
